export default "__VITE_ASSET__D97vu9ZG__"